import { IconProps } from "./IconProps";

const SideBarIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = "#0F5051",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M8.25 4.5V19.5H3.75C3.55109 19.5 3.36032 19.421 3.21967 19.2803C3.07902 19.1397 3 18.9489 3 18.75V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H8.25Z"
        fill="black"
        fillOpacity="0.04"
      />
      <path
        d="M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM3.75 14.25H5.25C5.44891 14.25 5.63968 14.171 5.78033 14.0303C5.92098 13.8897 6 13.6989 6 13.5C6 13.3011 5.92098 13.1103 5.78033 12.9697C5.63968 12.829 5.44891 12.75 5.25 12.75H3.75V11.25H5.25C5.44891 11.25 5.63968 11.171 5.78033 11.0303C5.92098 10.8897 6 10.6989 6 10.5C6 10.3011 5.92098 10.1103 5.78033 9.96967C5.63968 9.82902 5.44891 9.75 5.25 9.75H3.75V8.25H5.25C5.44891 8.25 5.63968 8.17098 5.78033 8.03033C5.92098 7.88968 6 7.69891 6 7.5C6 7.30109 5.92098 7.11032 5.78033 6.96967C5.63968 6.82902 5.44891 6.75 5.25 6.75H3.75V5.25H7.5V18.75H3.75V14.25ZM20.25 18.75H9V5.25H20.25V18.75Z"
        fill={color}
      />
    </svg>
  );
};
export default SideBarIcon;
